import React, { useEffect, useState } from "react";
import Breadcrumb from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Tab, Nav } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { IncomingInvoiceService } from "../../../services/incoming-invoice-service";
import IncomingInvoiceItems, { GdnItems } from "./Gdnitems";
import { ToastContainer } from "react-toastify";
import IncomingInvoicelist from "./Gdnlist";
import { GdnService } from "../../../services/gdn-service";

export const Content = (props) => {
  const { gdnID } = useParams();

  useEffect(() => {
    gdnDetailSearchID();
  }, []);

  const [gdnInfo, setGdnInfo] = useState({
    supplier_name: "",
    invoice_number: "",
    total_price: "",
    comment: "",
    sent_date: "",
    status: "",
  });

  const [gdnItemsinfo, setGdnItemsinfo] = useState([]);

  const gdnDetailSearchID = async () => {
    try {
      const result = await GdnService.gdnDetailsID(gdnID);
      const info = {};

      const dispatchdata = result;

      info.supplier_name = dispatchdata.publisher.name;
      info.invoice_number = dispatchdata.invoice_number;
      info.total_price = dispatchdata.total_price;
      info.comment = dispatchdata.comment;
      info.sent_date = dispatchdata.sent_date;
      info.status = dispatchdata.status;

      setGdnInfo(info);
      setGdnItemsinfo(dispatchdata.dispatchItems);
      
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
        </div>
        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Goods Dispatch Note(GDN)</h6>
            </div>
            <div className="ms-panel-body clearfix">
              <Tab.Container defaultActiveKey="tab13">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs d-flex nav-justified mb-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="tab13">Goods Dispatch Note(GDN)</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab14">Goods Dispatch Note(GDN) List</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="tab13">
                    <IncomingInvoicelist
                      supplier_name={gdnInfo.supplier_name}
                      invoice_number={gdnInfo.invoice_number}
                      total_price={gdnInfo.total_price}
                      comment={gdnInfo.comment}
                      sent_date={gdnInfo.sent_date}
                      status={gdnInfo.status}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab14">
                    <GdnItems gdnItemsInfo={gdnItemsinfo} />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
